import {useContext, useEffect, useState} from 'react'

import OptionsDelivery from './optionsDelivery/OptionsDelivery.jsx'
import AddressList from './addressList/AddressList.jsx'

import {
    DialogAddressRegistration,
    DialogAddressWithoutZipCode,
    DialogEnterZipCode,
    DialogLoading, DialogWarning
} from '../Dialogs.jsx'
import {
    getLocal, getSession,
    removeLocal,
    removeSession,
    setLocal,
} from '../../../hooks/useStorage/useStorage.jsx'
import {
    checkServiceArea,
    checkCityServiceArea,
    checkServiceRadius,
    editRegisterAddress,
    updateAddress
} from '../../../utils/utils.jsx'
import {getZipCode} from '../../../services/Apis.jsx'
import {Divider, Fab, Snackbar} from '@mui/material'
import {AddRounded as AddIcon} from '@mui/icons-material'

import {address as textsAddress, general as textsGeneral} from '../../../translate/Translate.jsx'
import {AddressContext} from '../../../context/AddressContext.jsx'
import {ShoppingCartContext} from '../../../context/ShoppingCartContext.jsx'

import {capitalizeFirstLetter, checkUndefined, isEmpty} from 'react-lf-tools'

import {motion} from 'framer-motion'
import './address.scss'

const Address = ({onClose, onNext, onDeliveryFee}) => {
    const {setRestartButton, setDeliveryFee, setDiscount} = useContext(ShoppingCartContext)
    const [deliveryMode, setDeliveryMode] = useState('')
    const [dialogEnterZipCode, setDialogEnterZipCode] = useState({
        open: false
    })
    const [dialogAddressWithoutZipCode, setDialogAddressWithoutZipCode] = useState({
        open: false,
        data: null
    })
    const [dialogAddressRegistration, setDialogAddressRegistration] = useState({
        open: false,
        data: {},
        isEditing: false,
        withoutZipCode: false
    })
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: ''
    })
    const [myAddress, setMyAddress] = useState([])
    const [dialogLoading, setDialogLoading] = useState({
        open: false,
        message: ''
    })
    const [dialogWarning, setDialogWarning] = useState({
        open: false,
        title: '',
        message: ''
    })

    const handleClickZipCode = async (zipCode) => {
        try {
            if (isEmpty(zipCode) || (zipCode.length < 9))
                return setSnackbar({open: true, message: textsAddress.invalidZipCode})
            setDialogEnterZipCode({open: false})
            setDialogLoading({open: true, message: textsAddress.searchingForZipCode})
            const response = await getZipCode(zipCode)
            if (response.sucesso) {
                const street = response?.endereco?.trim()
                const singleZipCode = (!response?.bairro || !street)
                const data = {
                    street: cleanStreet(street),
                    neighborhood: checkUndefined(response.bairro, ''),
                    city: checkUndefined(response.cidade, ''),
                    zipCode: checkUndefined(response.cep, ''),
                    uf: checkUndefined(response.uf, '')
                }
                if (singleZipCode) {
                    const isCityServiceArea = checkCityServiceArea(data.city)
                    if (!isCityServiceArea) return setSnackbar({
                        open: true,
                        message: textsAddress.weDoNotServeYourRegion
                    })
                    return setDialogAddressWithoutZipCode({
                        open: true,
                        data: data,
                        isEditing: false
                    })
                }
                const {attendance, message} = checkServiceArea(data)
                const {isServiceRadius, latitude, longitude, error} =
                    await checkServiceRadius(data, false)
                if (error) return setDialogWarning({
                    open: true,
                    title: textsGeneral.failure,
                    message: textsAddress.coordinatesNotFound
                })
                if ((!data.latitude || !data.longitude) && latitude && longitude) {
                    const updatedAddress = {...data, latitude, longitude}
                    editRegisterAddress(updatedAddress)
                }
                if (!attendance && !isServiceRadius) return setSnackbar({
                    open: true,
                    message: message
                })
                setDialogAddressRegistration({
                    open: true,
                    data: data,
                    isEditing: false
                })
            } else {
                setSnackbar({open: true, message: textsAddress.zipCodeNotFound})
            }
        } finally {
            setDialogLoading({open: false})
        }
    }

    const cleanStreet = street => {
        try {
            return street.split('-')[0].trim()
        } catch (e) {
            console.error(e.message)
        }
        return street
    }

    const handleCloseZipCode = () => setDialogEnterZipCode({open: false})

    const handleClickNotZipCode = () => {
        setDialogEnterZipCode({open: false})
        setDialogAddressWithoutZipCode({open: true, data: null})
    }

    const handleCloseSnackbar = () => setSnackbar({...snackbar, open: false})

    const handleClickAddressRegistration = async (address) => {
        const myAddress = getLocal('myAddress', [])
        if (isEmpty(address.id)) {
            const {attendance, deliveryFee, id_loja, message} = checkServiceArea(address)
            const {isServiceRadius, exceededRadiusLimit, radiusDeliveryFee, latitude, longitude, error} =
                await checkServiceRadius(address, true)
            if (error) return setDialogWarning({
                open: true,
                title: textsGeneral.failure,
                message: textsAddress.coordinatesNotFound
            })
            if (exceededRadiusLimit && !attendance) {
                setDialogAddressWithoutZipCode({open: false, data: null})
                setDialogAddressRegistration({...dialogAddressRegistration, open: false})
                setSnackbar({open: true, message: textsAddress.outsideServiceRadius})
                return
            }
            if (!attendance && !isServiceRadius) {
                setDialogAddressWithoutZipCode({open: false, data: null})
                setSnackbar({open: true, message: message})
                return
            }
            const finalFee = isServiceRadius ? radiusDeliveryFee : deliveryFee
            setLocal('deliveryFee', finalFee)
            setLocal('idStore', id_loja)
            setLocal('deliveryMode', 'delivery')
            setDeliveryMode('delivery')
            const upadateAddress = {...address, latitude, longitude, id: new Date().getTime()}
            myAddress.push(upadateAddress)
            setLocal('myAddress', myAddress)
            setMyAddress(myAddress)
            setLocal('address', upadateAddress)
            updateAddress()
            setDeliveryFee(isServiceRadius ? radiusDeliveryFee : deliveryFee)
            onNext()
        } else {
            const index = myAddress.findIndex(m => (m.id === address.id))
            myAddress[index] = address
            setLocal('myAddress', myAddress)
            setMyAddress(myAddress)
            const selectedAddress = getLocal('address', {})
            if (address.id === selectedAddress.id) {
                setLocal('address', address)
            }
        }
        setDialogAddressRegistration({
            open: false,
            data: {},
            isEditing: false
        })
        setDialogAddressWithoutZipCode({
            open: false,
            data: null
        })
    }

    const handleCloseAddressRegistration = () => setDialogAddressRegistration({open: false, data: {}})

    const handleCloseAddressWithoutZipCode = () => setDialogAddressWithoutZipCode({open: false, data: null})

    const handleClickDialogWarning = () => setDialogWarning({...dialogWarning, open: false})

    const handleClickAddAddress = () => {
        setDialogEnterZipCode({open: true})
    }

    const handleClickOptionDelivery = (mode) => {
        removeSession('scheduledOrderType')
        removeSession('scheduledTime')
        if ((mode === 'delivery') && isEmpty(getLocal('myAddress')) && isEmpty(getLocal('address'))) {
            const deliveryMode = getLocal('deliveryMode')
            if (deliveryMode === 'takeaway') {
                setLocal('deliveryMode', '')
                setDeliveryMode('')
            }
            setDialogEnterZipCode({open: true})
            removeLocal('takeawayOptions')
            return
        } else if (mode === 'delivery') {
            setSnackbar({open: true, message: textsAddress.selectDeliveryAddress})
            removeLocal('takeawayOptions')
        } else if (mode === 'takeaway') {
            setSnackbar({open: true, message: textsAddress.selectTakeawayMode})
            removeLocal('address')
            checkFreeDelivery()
        }
        setLocal('deliveryMode', mode)
        setDeliveryMode(mode)
    }

    const checkFreeDelivery = () => {
        try {
            const freeDelivery = getLocal('freeDelivery', 0)
            if (freeDelivery !== 0) {
                const discountCoupon = getSession('discountCoupon', {})
                if (discountCoupon?.discountCoupon === 'freeDelivery') {
                    removeSession('discountCoupon')
                    removeSession('discount')
                    setDiscount(0)
                }
            }
        } catch (e) {

        }
    }

    const handleClickEditAddress = (event, address) => {
        event.stopPropagation()
        setDialogAddressRegistration({
            open: true,
            data: address,
            isEditing: true,
            withoutZipCode: isEmpty(address.zipCode)
        })
    }

    const handleClickDeleteAddress = (event, address) => {
        event.stopPropagation()
        const myAddress = getLocal('myAddress', [])
        const index = myAddress.findIndex(m => (m.id === address.id))
        myAddress.splice(index, 1)
        setLocal('myAddress', myAddress)
        setMyAddress(myAddress)
        const selectedAddress = getLocal('address', {})
        if (myAddress.length === 0) {
            removeLocal('deliveryMode')
            removeLocal('address')
            setDeliveryMode('')
        } else if (address.id === selectedAddress.id) {
            removeLocal('address')
        }
        removeLocal('deliveryFee')
        updateAddress()
    }

    const handleClickAddress = async (address, deliveryMode) => {
        if (deliveryMode === 'delivery') {
            const {attendance, deliveryFee, id_loja, message} = checkServiceArea(address)
            const {isServiceRadius, exceededRadiusLimit, radiusDeliveryFee, latitude, longitude, error} =
                await checkServiceRadius(address, false)
            if (error) return setDialogWarning({
                open: true,
                title: textsGeneral.failure,
                message: textsAddress.coordinatesNotFound
            })
            if ((!address?.latitude || !address?.longitude) && (!!latitude && !!longitude)) {
                address.latitude = latitude
                address.longitude = longitude
                editRegisterAddress(address)
            }
            if (exceededRadiusLimit && !attendance) return setSnackbar({
                open: true,
                message: textsAddress.outsideServiceRadius
            })
            if (!attendance && !isServiceRadius) return setSnackbar({open: true, message: message})
            const finalFee = isServiceRadius ? radiusDeliveryFee : deliveryFee
            checkPayment('TAKEAWAY')
            setLocal('address', address)
            setLocal('deliveryMode', deliveryMode)
            setLocal('idStore', id_loja)
            setDeliveryMode(deliveryMode)
            setLocal('deliveryFee', finalFee)
            setDeliveryFee(finalFee)
            onNext()
            setRestartButton(new Date().getTime().toString())
        } else if (deliveryMode === 'takeaway') {
            checkPayment('DELIVERY')
            const takeawayOptions = {store: address, id_loja: import.meta.env.VITE_ID_STORE}
            setLocal('takeawayOptions', takeawayOptions)
            setLocal('deliveryMode', deliveryMode)
            removeLocal('deliveryFee')
            setLocal('idStore', import.meta.env.VITE_ID_STORE)
            setDeliveryMode(deliveryMode)
            onNext()
            onDeliveryFee()
            setRestartButton(new Date().getTime().toString())
        } else {
            checkPayment('DELIVERY')
            setLocal('takeawayOptions', address)
            setLocal('infoAddress', capitalizeFirstLetter(address.address))
            setLocal('deliveryMode', 'takeaway')
            setLocal('idStore', address?.id_loja || '0')
            removeLocal('deliveryFee')
            onDeliveryFee()
            setDeliveryMode('takeaway')
            onClose()
            setRestartButton(new Date().getTime().toString())
        }
    }

    const checkPayment = (mode) => {
        const cashPayments = getLocal('cashPayments')
        const physicalPayments = getLocal('physicalPayments')
        const onlinePayments = getLocal('onlinePayments')
        const payment = getSession('payment')
        if ((payment.code === 'DIN') && (cashPayments === mode || cashPayments === 'OFF')) {
            removeSession('payment')
            removeSession('change')
            onClose()
        }
        if ((payment.online === 'False') && (physicalPayments === mode || physicalPayments === 'OFF')) {
            removeSession('payment')
            removeSession('change')
            onClose()
        }
        if ((payment.code !== 'PIX' && payment.online === 'True') && (onlinePayments === mode || onlinePayments === 'OFF')) {
            removeSession('payment')
            removeSession('change')
            onClose()
        }
    }

    useEffect(() => {
        checkDeliveryMode()
        checkMyAddress()
    }, [])

    const checkMyAddress = () => {
        const myAddress = getLocal('myAddress', [])
        setMyAddress(myAddress)
    }

    const checkDeliveryMode = () => {
        const deliveryMode = getLocal('deliveryMode')
        setDeliveryMode(deliveryMode)
    }

    return <motion.div
        className={'address'}
        initial={{x: 400}}
        animate={{x: 0}}
        transition={{duration: 0.3}}>
        <div className={'container-address'}>
            <AddressContext.Provider value={{deliveryMode, setDeliveryMode}}>
                <OptionsDelivery
                    onClick={handleClickOptionDelivery}/>
                <Divider/>
                <AddressList
                    myAddress={myAddress}
                    onEdit={handleClickEditAddress}
                    onDelete={handleClickDeleteAddress}
                    onClick={handleClickAddress}/>
            </AddressContext.Provider>
        </div>
        {(deliveryMode === 'delivery') && <div className={'div-add-address'}>
            <div className={'div-float'}>
                <Fab
                    color={'secondary'}
                    onClick={handleClickAddAddress}>
                    <AddIcon className={'icon'}/>
                </Fab>
            </div>
        </div>}
        <>
            <DialogLoading
                open={dialogLoading.open}
                message={dialogLoading.message}/>
            <DialogEnterZipCode
                open={dialogEnterZipCode.open}
                onClick={handleClickZipCode}
                onClose={handleCloseZipCode}
                notZipCode={handleClickNotZipCode}
            />
            {(dialogAddressRegistration.open) && <DialogAddressRegistration
                open={dialogAddressRegistration.open}
                data={dialogAddressRegistration.data}
                isEditing={dialogAddressRegistration.isEditing}
                withoutZipCode={dialogAddressRegistration.withoutZipCode}
                onClick={handleClickAddressRegistration}
                onClose={handleCloseAddressRegistration}
            />}
            {(dialogAddressWithoutZipCode.open) && <DialogAddressWithoutZipCode
                open={dialogAddressWithoutZipCode.open}
                data={dialogAddressWithoutZipCode.data}
                onClick={handleClickAddressRegistration}
                onClose={handleCloseAddressWithoutZipCode}
            />}
            <DialogWarning
                open={dialogWarning.open}
                title={dialogWarning.title}
                message={dialogWarning.message}
                onClick={handleClickDialogWarning}
            />
            <Snackbar
                open={snackbar.open}
                autoHideDuration={1600}
                onClose={handleCloseSnackbar}
                message={snackbar.message}/>
        </>
    </motion.div>
}

export default Address
